"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var error_const_1 = require("../const/error-handling/error.const");
var de = __importStar(require("../locales/de.json"));
var en = __importStar(require("../locales/en.json"));
var englishTranslation = __assign(__assign({}, en), Object.fromEntries(Object.values(error_const_1._ErrorMessages).map(function (msg) { return ['error', msg.en]; })));
i18next_1.default.init({
    lng: 'de', // Set the default language
    resources: {
        en: {
            translation: englishTranslation,
        },
        de: {
            translation: de,
        },
    },
});
//TODO get language and currency codes based on the set language
i18next_1.default.transformCurrency = function (price, language, settings) {
    if (language === void 0) { language = 'de-DE'; }
    if (settings) {
        return new Intl.NumberFormat(language, settings).format(+price);
    }
    else {
        return new Intl.NumberFormat(language, {
            minimumFractionDigits: +price % 1 != 0 ? 2 : 0,
            maximumFractionDigits: 2,
        }).format(+price);
    }
};
exports.default = i18next_1.default;
